import React from "react";

const Toggle = ({ className, disabled, ...props }) => {
  return (
    <label className="relative cursor-pointer w-16 h-8">
      <input
        type="checkbox"
        checked={disabled}
        {...props}
        className="sr-only peer"
      />
      <div className="w-full h-full rounded-full transition-colors duration-300 bg-red-500 peer-checked:bg-green-500">
      </div>

      <div
        className="absolute left-0 top-0 w-8 h-8 bg-white rounded-full shadow-md transform transition-transform duration-300 peer-checked:translate-x-8 flex items-center justify-center"
      >
        {disabled ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            className="w-5 h-5 text-green-600"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            className="w-5 h-5 text-red-600"
          >
            <path d="M18 6 6 18" />
            <path d="M6 6 18 18" />
          </svg>
        )}
      </div>
    </label>
  );
};

export default Toggle;